import { DateTime } from 'luxon'

// Human-friendly "when" for conversation lists and messages. Mirrors
// Website-Frontend's dateTime.ts helpers (keep in sync).
export const formatHumanTime = (
    isoOrDate: string | Date,
    now: DateTime = DateTime.local()
): string => {
    const then =
        typeof isoOrDate === 'string'
            ? DateTime.fromISO(isoOrDate)
            : DateTime.fromJSDate(isoOrDate)
    const local = then.toLocal()
    const seconds = Math.max(0, now.diff(local, 'seconds').seconds)
    if (seconds < 45) return 'just now'
    if (seconds < 90) return '1 min ago'
    const minutes = Math.round(seconds / 60)
    if (minutes < 60) return `${minutes} min ago`
    const hours = Math.round(minutes / 60)
    if (hours < 6) return hours === 1 ? '1 hour ago' : `${hours} hours ago`
    if (local.hasSame(now, 'day')) return `Today at ${local.toFormat('h:mm a')}`
    if (local.hasSame(now.minus({ days: 1 }), 'day'))
        return `Yesterday at ${local.toFormat('h:mm a')}`
    if (local.hasSame(now, 'year')) return local.toFormat("MMM d 'at' h:mm a")
    return local.toFormat('MMM d, yyyy')
}

export const formatFullDateTime = (isoOrDate: string | Date): string => {
    const then =
        typeof isoOrDate === 'string'
            ? DateTime.fromISO(isoOrDate)
            : DateTime.fromJSDate(isoOrDate)
    return then.toLocal().toFormat("cccc, MMMM d, yyyy 'at' h:mm a")
}
